import * as moment from 'moment';
import * as _ from 'lodash';
import { FormEvent } from 'react';
import { IListItem, IRecipientProfilePostTransplantData } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel, Radio, Row } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';

interface IProps {
    data: IRecipientProfilePostTransplantData,
    validation: IValidation,
    swapList: IListItem[],
    transportMethodList: IListItem[],
    logisticsProviderList: IListItem[],
    onChange: (data: IRecipientProfilePostTransplantData) => void
}

const AdminOnly = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let data = _.cloneDeep(props.data);
        let { name, value } = e.currentTarget;

        if (name == 'swapType') {
            data.swapType = parseInt(value);
        }

        if (name == 'transplantDate') {
            data.transplantDate = value;
        }

        if (name == 'shippedMethod') {
            data.shippedMethod = parseInt(value);
        }

        if (name == 'courierJobNumber') {
            data.courierJobNumber = value;
        }

        if (name == 'isKflMatch') {
            data.isKflMatch = parseInt(value) == 1;
        }

        if (name == 'logisticsProvider') {
            data.logisticsProvider = value;
        }

        if (name == 'transportationCost') {
            data.transportationCost = value;
        }

        props.onChange(data);
    };

    return (
        <Panel>
            <Panel.Heading>Admin Only Post-Transplant Fields</Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Patient Type:</Col>
                                <Col xs={12} lg={3}>
                                    {/* <FormControl
                                        name='swapType'
                                        componentClass='select'
                                        style={{ width: 300 }}
                                        value={props.data.swapType}
                                        onChange={handleDataChange}
                                    >
                                        {props.swapList.map((swap, index) =>
                                            <option key={`swap-${index}`} value={swap.id}>{swap.description}</option>
                                        )}
                                    </FormControl> */}
                                    <div className='form-control-static'>{props.data.patientType}</div>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Swap Type:</Col>
                                <Col xs={12} lg={3}>
                                    <FormControl
                                        name='swapType'
                                        componentClass='select'
                                        style={{ width: 300 }}
                                        value={props.data.swapType}
                                        onChange={handleDataChange}
                                    >
                                        {props.swapList.map((swap, index) =>
                                            <option key={`swap-${index}`} value={swap.id}>{swap.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={6}>
                            <FormGroup validationState={props.validation.transplantDate == false ? 'error' : null}>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Transplant Date:</Col>
                                <Col xs={12} lg={3}>
                                    <MaskedInput
                                        name='transplantDate'
                                        className='form-control'
                                        mask='11/11/1111'
                                        placeholder='mm/dd/yyyy'
                                        style={{ width: 300 }}
                                        value={props.data.transplantDate != null ? moment(props.data.transplantDate).format('MM/DD/YYYY') : ''}
                                        onChange={handleDataChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Kidney Transport Method:</Col>
                                <Col xs={12} lg={3}>
                                    <FormControl
                                        name='shippedMethod'
                                        componentClass='select'
                                        value={props.data.shippedMethod}
                                        onChange={handleDataChange}
                                        style={{ width: 300 }}
                                    >
                                        {props.transportMethodList.map((transport, index) =>
                                            <option key={`transport-${index}`} value={transport.id}>{transport.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Courier Job #:</Col>
                                <Col xs={12} lg={3}>
                                    <FormControl
                                        name='courierJobNumber'
                                        style={{ width: 300 }}
                                        value={props.data.courierJobNumber}
                                        onChange={handleDataChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Is Kidney for Life Recipient?</Col>
                                <Col xs={12} lg={3}>
                                    <div style={{ minHeight: 34 }}>
                                        <Radio inline name='isKflMatch' value={1} checked={props.data.isKflMatch != null ? props.data.isKflMatch : false} onChange={handleDataChange}>Yes</Radio>
                                        <Radio inline name='isKflMatch' value={0} checked={props.data.isKflMatch != null ? !props.data.isKflMatch : false} onChange={handleDataChange}>No</Radio>
                                    </div>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Logistics Provider:</Col>
                                <Col xs={12} lg={3}>
                                    <FormControl
                                        name='logisticsProvider'
                                        componentClass='select'
                                        style={{ width: 300 }}
                                        value={props.data.logisticsProvider}
                                        onChange={handleDataChange}
                                    >
                                        {props.logisticsProviderList.map((logistics, index) =>
                                            <option key={`logisticsProvider-${index}`} value={logistics.id}>{logistics.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    {/* <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup validationState={props.validation.transportCost == false ? 'error' : null}>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>Transportation Cost:</Col>
                                <Col xs={12} lg={3}>
                                    <FormControl
                                        name='transportationCost'
                                        style={{ width: 300 }}
                                        value={props.data.transportationCost}
                                        onChange={handleDataChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row> */}
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default AdminOnly;